import "core-js/modules/es.array.push.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-00414de8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home-hero",
  "aria-labelledby": "home-hero-title"
};
const _hoisted_2 = {
  class: "hero-inner"
};
const _hoisted_3 = {
  class: "hero-copy"
};
const _hoisted_4 = {
  id: "home-hero-title"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_6 = {
  class: "hero-highlight"
};
const _hoisted_7 = {
  class: "everyone"
};
const _hoisted_8 = {
  class: "hero-description"
};
const _hoisted_9 = {
  class: "hero-actions"
};
const _hoisted_10 = ["aria-label"];
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "hero-art"
};
const _hoisted_13 = ["src", "alt"];
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { ArrowRightOutlined, RocketOutlined } from '@ant-design/icons-vue';
import { useI18n } from 'vue-i18n';
import store from '@/store';
import heroIllustration from '@/assets/home1/hero-illustration.png';
import usersIcon from '@/assets/home1/stat-users.png';
import valueIcon from '@/assets/home1/stat-value.png';
import transactionsIcon from '@/assets/home1/stat-transactions.png';
import countriesIcon from '@/assets/home1/stat-countries.png';
export default {
  __name: 'HomeHero',
  setup(__props) {
    const router = useRouter();
    const {
      t
    } = useI18n();
    const stats = computed(() => [{
      icon: usersIcon,
      value: '250K+',
      label: t('homepage.hero.stats.happyUsers')
    }, {
      icon: valueIcon,
      value: '$128M+',
      label: t('homepage.hero.stats.tvlLocked')
    }, {
      icon: transactionsIcon,
      value: '15M+',
      label: t('homepage.hero.stats.transactions')
    }, {
      icon: countriesIcon,
      value: '120+',
      label: t('homepage.hero.stats.countries')
    }]);
    const launchApp = () => {
      router.push(store.state.token ? {
        name: 'walletOverview'
      } : {
        name: 'login'
      });
    };
    const exploreEcosystem = () => {
      const section = document.querySelector('.home-coin-list');
      if (section) {
        window.scrollTo({
          top: section.getBoundingClientRect().top + window.scrollY - 72,
          behavior: 'smooth'
        });
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("h1", _hoisted_4, [_createElementVNode("span", null, [_createTextVNode(_toDisplayString(_unref(t)('homepage.hero.title')), 1), _hoisted_5, _createTextVNode(_toDisplayString(_unref(t)('homepage.hero.titleWeb3')), 1)]), _createElementVNode("span", _hoisted_6, [_createTextVNode(_toDisplayString(_unref(t)('homepage.hero.highlight')) + " ", 1), _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)('homepage.hero.everyone')), 1)])]), _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(t)('homepage.hero.description')), 1), _createElementVNode("div", _hoisted_9, [_createElementVNode("button", {
        class: "hero-button hero-button-primary",
        type: "button",
        onClick: launchApp
      }, [_createTextVNode(_toDisplayString(_unref(t)('homepage.hero.launchApp')) + " ", 1), _createVNode(_unref(RocketOutlined), {
        class: "hero-action-icon",
        "aria-hidden": "true"
      })]), _createElementVNode("button", {
        class: "hero-button hero-button-secondary",
        type: "button",
        onClick: exploreEcosystem
      }, [_createTextVNode(_toDisplayString(_unref(t)('homepage.hero.exploreEcosystem')) + " ", 1), _createVNode(_unref(ArrowRightOutlined), {
        class: "hero-action-icon",
        "aria-hidden": "true"
      })])]), _createElementVNode("div", {
        class: "hero-stats",
        "aria-label": _unref(t)('homepage.hero.statsAriaLabel')
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(stats), stat => {
        return _openBlock(), _createElementBlock("div", {
          key: stat.label,
          class: "hero-stat"
        }, [_createElementVNode("img", {
          src: stat.icon,
          alt: ""
        }, null, 8, _hoisted_11), _createElementVNode("div", null, [_createElementVNode("strong", null, _toDisplayString(stat.value), 1), _createElementVNode("span", null, _toDisplayString(stat.label), 1)])]);
      }), 128))], 8, _hoisted_10)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("img", {
        src: _unref(heroIllustration),
        alt: _unref(t)('homepage.hero.imageAlt')
      }, null, 8, _hoisted_13)])])]);
    };
  }
};